// src/icons/svgs/eye.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgEye = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 36, height: 37, fill: "none", viewBox: "0 0 36 37", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M33.708 19.684c.39-.472.39-1.118 0-1.59C31.753 15.727 25.46 8.889 18 8.889c-7.46 0-13.753 6.838-15.708 9.205a1.23 1.23 0 0 0 0 1.59C4.247 22.05 10.54 28.889 18 28.889c7.46 0 13.753-6.838 15.708-9.205m-15.526 4.49a5 5 0 1 0 0-10 5 5 0 0 0 0 10", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgEye);
var eye_default = ForwardRef;
export {
  eye_default as Eye
};
